import styled from 'styled-components'
import { BrgButton, FlexBox } from '@brg/ui'
import { LayoutConst } from 'core'

export const Wrapper = styled(FlexBox)`
  width: 640px;
  background: #FEFEFE;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  position: relative;
  padding: 40px 40px;
  flex-flow: column;
  align-items: center;
  gap: 16px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 320px;
    padding: 32px 20px 24px;
  }
`

export const Title = styled.div`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.02em;
  color: #151514;
  text-align: center;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 18px;
    line-height: 24px;
  }
`

export const Description = styled.div`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #656565;
  text-align: center;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    line-height: 18px;
  }
`

export const ButtonRow = styled(FlexBox)`
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-top: 8px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-flow: column;
    gap: 8px;
  }
`

export const ActionButton = styled(BrgButton)`
  flex: 1;
  font-weight: 600;
  font-size: 15px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
  }
`

export const LeaveButton = styled.button`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #909090;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-top: 4px;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: #656565;
  }
`

export const CloseWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;

  &:hover svg path {
    fill: ${(p: any) => p.theme.modal?.closeColor};
  }
`
import styled from 'styled-components'
import { BrgButton, FlexBox } from '@brg/ui'
import { LayoutConst } from 'core'

export const Wrapper = styled(FlexBox)`
  width: 640px;
  background: #FEFEFE;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  position: relative;
  padding: 40px 40px;
  flex-flow: column;
  align-items: center;
  gap: 16px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 320px;
    padding: 32px 20px 24px;
  }
`

export const Title = styled.div`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.02em;
  color: #151514;
  text-align: center;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 18px;
    line-height: 24px;
  }
`

export const Description = styled.div`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #656565;
  text-align: center;

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    line-height: 18px;
  }
`

export const ButtonRow = styled(FlexBox)`
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-top: 8px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-flow: column;
    gap: 8px;
  }
`

export const ActionButton = styled(BrgButton)`
  flex: 1;
  font-weight: 600;
  font-size: 15px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
  }
`

export const LeaveButton = styled.button`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #909090;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-top: 4px;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: #656565;
  }
`

export const CloseWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;

  &:hover svg path {
    fill: ${(p: any) => p.theme.modal?.closeColor};
  }
`
